import React, { useState } from 'react';
import ActionButton from 'components/ActionButton';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import CardNumber from './CardInputFields/CardNumber';
import CardExpiry from './CardInputFields/CardExpiry';
import CardCVV from './CardInputFields/CardCVV';
import { Error } from 'components/message/Error';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers';
import { IPayments } from 'interfaces/payment';
import { showError } from 'utils';
import { Loading } from 'components/loading/Loading';

const validationSchema = yup.object().shape({
  nameOnCard: yup.string().required('Name on Card is a required field'),
});

type FormData = {
  nameOnCard: string;
}

const styles = {
  style: {
    base: {
      'fontWeight': '600',
      'fontFamily': 'Segoe UI, sans-serif',
      '::placeholder': { color: 'rgba(0, 0, 0, 0.4)' },
    },
    invalid: {
      color: '#F37272',
    },
  },
};

const AddNewCardForm: React.FC<IPayments.IAddNewCardFormProps> = props => {
  const { register, handleSubmit, errors } = useForm<FormData>({
    resolver: yupResolver(validationSchema),
  });
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const createPaymentMethodFn = handleSubmit(async () => {
    if (stripe && elements) {
      try {
        const card = elements.getElement('cardNumber');
        setLoading(true);
        // @ts-ignore
        const { error, token } = await stripe.createToken(card);
        if (error) {
          showError(error.message || '');
        }
        if (token) {
          //@ts-ignore
          props.onCardAdded && props.onCardAdded(token);
        }
      } catch (e: any) {
        showError(e.message);
      }finally{
        setLoading(false);
      }
    }
  });

  return (
    <form className={`card-section ${props.customClass || ''}`}>
      {error && <Error message={error} />}
      {loading && <Loading/>}
      <div className='inputs-container'>
        <div>
          <div className='form-group'>
            <label>Name on Card</label>
            <input
              name='nameOnCard'
              ref={register}
              value={name}
              onChange={e => setName(e.target.value)}
            />
            {errors.nameOnCard && <Error message={errors.nameOnCard.message} />}
          </div>
          <CardNumber styles={styles} />
          <div className="row">
            <div className="col">
              <CardExpiry styles={styles} />
            </div>
            <div className="col">
              <CardCVV styles={styles} />
            </div>
          </div>
        </div>
      </div>
      <div className="pt-2 buttons-container">
        <div className="d-flex">
          <ActionButton
            text={'CANCEL'}
            active={true}
            isLoading={false}
            onClick={props.onCancel}
          />
          <ActionButton
            text={'Add'}
            active={true}
            isLoading={false}
            onClick={createPaymentMethodFn}
          />
        </div>
      </div>
    </form>
  );
};

export default AddNewCardForm;
